export type PossibleTypesResultData = {
  possibleTypes: {
    Favoritable: ["Collection", "ReflectionQuestion", "Resource"];
    Media: ["AudioRecording", "Video"];
    Node: [
      "AnnouncementContent",
      "AudioRecording",
      "CleverSection",
      "Collection",
      "ConnectCode",
      "ExportUserDataRequest",
      "Image",
      "LibraryTag",
      "Message",
      "Notification",
      "ReflectionQuestion",
      "Resource",
      "School",
      "Session",
      "Student",
      "StudentGroup",
      "StudentSession",
      "Teacher",
      "Video",
    ];
    Timestamps: ["Message"];
    User: ["Student", "Teacher"];
  };
};
const result: PossibleTypesResultData = {
  possibleTypes: {
    Favoritable: ["Collection", "ReflectionQuestion", "Resource"],
    Media: ["AudioRecording", "Video"],
    Node: [
      "AnnouncementContent",
      "AudioRecording",
      "CleverSection",
      "Collection",
      "ConnectCode",
      "ExportUserDataRequest",
      "Image",
      "LibraryTag",
      "Message",
      "Notification",
      "ReflectionQuestion",
      "Resource",
      "School",
      "Session",
      "Student",
      "StudentGroup",
      "StudentSession",
      "Teacher",
      "Video",
    ],
    Timestamps: ["Message"],
    User: ["Student", "Teacher"],
  },
};
export default result;
